import { useBaseQuery } from "./utils/useBaseQuery.js";
export function useLazyQuery(query, options) {
    return useBaseQuery(query, options, true);
}
//# sourceMappingURL=useLazyQuery.js.map


//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/@apollo/client/react/hooks/useLazyQuery.js
// module id = 1997
// module chunks = 69